import styled from 'styled-components';
import StatusIndicator from '../status-indicator/StatusIndicator';
export const FinantialItem = styled.div `
  position: relative;

  display: flex;

  width: 100%;

  margin-top: 3.8rem;

  border: 1px solid
    ${({ borderColor, theme }) => borderColor ? borderColor : theme.colors.surface.interactiveDefault};
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.surface.interactiveDefault};

  ${({ theme }) => theme.media.tablet `
    margin-top: 2.7rem;
  `};
`;
export const CustomStatusIndicator = styled(StatusIndicator) `
  top: -3.7rem;
  left: -0.8px;

  z-index: ${({ theme }) => theme.zIndex.low};

  &:after {
    height: 46.5px;
    top: -1.1px;
    right: -6.7px;
  }

  ${({ theme }) => theme.media.laptop `
    &:hover {
      z-index: 2;
    }
  `}

  ${({ theme }) => theme.media.tablet `
      top: -2.7rem;
      left: -0.8px;
      
      padding:1rem 0 0 1rem;
       
      &:after {
        height: 3.5rem;
        top: -0.5px;
        right: -4px;
      }
  `};
`;
//# sourceMappingURL=styles.js.map